import { render, staticRenderFns } from "./dwell.vue?vue&type=template&id=5b79c110&"
import script from "./dwell.vue?vue&type=script&lang=js&"
export * from "./dwell.vue?vue&type=script&lang=js&"
import style0 from "./dwell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports